export const FAST_GALLERY_MAPPERS_SELECTORS = {
  parentSelector: '.container',
  itemSelector: '.item',
};
